export default __webpack_public_path__ + "static/media/moreoptions-white.8163b5c2.svg";